// ✨ НОВАЯ ФУНКЦИЯ ДЛЯ ГЕНЕРАЦИИ ЦВЕТА, чтобы для пользователей был один и тот же цвет, как вотцапе и телеграмме
// /utils/getUserColor.ts (или где у вас находится функция)

// ✨ Функция теперь возвращает объект стиля React
export const getUserColor = (userId?: string | null): React.CSSProperties => {
  // Если ID отсутствует, возвращаем стиль для цвета по умолчанию
  if (!userId) {
    return { color: '#94a3b8' }; // Это цвет text-slate-400
  }

  // --- Генерация уникального оттенка (Hue) ---
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = userId.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Используем остаток от деления на 360, чтобы получить градус на цветовом круге
  const hue = Math.abs(hash % 360);

  // --- Фиксируем Насыщенность и Яркость для красивых и читабельных цветов ---
  const saturation = 75; // % - делаем цвета сочными
  const lightness = 60;  // % - делаем цвета достаточно светлыми для тёмного фона

  // Возвращаем объект стиля, который React может применить к элементу
  return {
    color: `hsl(${hue}, ${saturation}%, ${lightness}%)`,
  };
};
